import { render } from "./VideoGrid.vue?vue&type=template&id=6fdf43cf&scoped=true"
import script from "./VideoGrid.vue?vue&type=script&lang=js"
export * from "./VideoGrid.vue?vue&type=script&lang=js"

import "./VideoGrid.vue?vue&type=style&index=0&id=6fdf43cf&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdf43cf"]])

export default __exports__